import * as React from 'react';
import List from '@mui/material/List';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';

import {Link} from "react-router";
import {stringAvatar, stringToColor} from "../../utils/color";
import MdiIcon from "../../share/components/mdi/MdiIcon.tsx";
import { mdiTree } from "@mdi/js";
import {Session} from "../../app/slices/sessionSlice";
import Divider from '@mui/material/Divider';
import { t } from "@lingui/core/macro";

export function secondaryList(session: Session | undefined) {
    return [
        ...(session?.hasPermission('', 'applications/timber/entities/TimberClasses/list/view') ?
            [{
                path: '/dashboard/timber-classes',
                name: 'TimberClasses',
                label: t`Timber Classes`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/ThicknessClasses/list/view') ?
            [{
                path: '/dashboard/thickness-classes',
                name: 'ThicknessClasses',
                label: t`Thickness Classes`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/TimberTypes/list/view') ?
            [{
                path: '/dashboard/timber-types',
                name: 'TimberTypes',
                label: t`Timber Types`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/PricingProfiles/list/view') ?
            [{
                path: '/dashboard/pricing-profiles',
                name: 'PricingProfiles',
                label: t`Pricing Profiles`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/Buyers/list/view') ?
            [{
                path: '/dashboard/buyers',
                name: 'Buyers',
                label: t`Buyers`,
            }] : []),
        
        
        
        ...(session?.hasContextPermission('Buyers', 'applications/timber/entities/Buyers/read/view')
            && session?.scopeGroupContext?.scopeContexts && session?.scopeGroupContext.scopeContexts['Buyers'] ?
            [{
                path: '/dashboard/buyers/scoped',
                name: 'Buyers',
                label: t`Buyer`,
            }] : []),
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/RoadCarriers/list/view') ?
            [{
                path: '/dashboard/road-carriers',
                name: 'RoadCarriers',
                label: t`Road Carriers`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/Contractors/list/view') ?
            [{
                path: '/dashboard/contractors',
                name: 'Contractors',
                label: t`Contractors`,
            }] : []),
        
        
        
        
        
        ...(session?.hasContextPermission('Contractors', 'applications/timber/entities/Contractors/read/view')
            && session?.scopeGroupContext?.scopeContexts && session?.scopeGroupContext.scopeContexts['Contractors'] ?
            [{
                path: '/dashboard/contractors/scoped',
                name: 'Contractors',
                label: t`Contractor`,
            }] : []),
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/ForestOwners/list/view') ?
            [{
                path: '/dashboard/forest-owners',
                name: 'ForestOwners',
                label: t`Forest Owners`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/Providers/list/view') ?
            [{
                path: '/dashboard/providers',
                name: 'Providers',
                label: t`Providers`,
            }] : []),
        
        ...(session?.hasContextPermission('Providers', 'applications/timber/entities/Providers/read/view')
            && session?.scopeGroupContext?.scopeContexts && session?.scopeGroupContext.scopeContexts['Providers'] ?
            [{
                path: '/dashboard/providers/scoped',
                name: 'Providers',
                label: t`Provider`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/AccountingUsers/list/view') ?
            [{
                path: '/dashboard/accounting-users',
                name: 'AccountingUsers',
                label: t`Accounting Users`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/timber/entities/Cuttings/list/view') ?
            [{
                path: '/dashboard/cuttings',
                name: 'Cuttings',
                label: t`Cuttings`,
            }] : []),
        
        
        
        
        
        
        
        
    ]
}

export function secondaryListItems(open: boolean, session: Session | undefined, handleClick: (packageName: string) => void) {
    
    const list = secondaryList(session)
    
    if (list.length === 0) {
        return undefined    
    }
    
    return (
        <React.Fragment>
            <Divider sx={ {my: 1} }/>
            <ListItemButton
                onClick={() => handleClick('timber')}
                data-testid="timber"
            >
                <ListItemIcon>
                    <MdiIcon d={ mdiTree } htmlColor="lightgreen" />
                </ListItemIcon>
                <ListItemText primary={t`Timberstorage`}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    { list.map(item =>
                        <ListItemButton
                            key={item.path}
                            component={Link}
                            to={item.path}
                            data-testid={item.name}
                            aria-label={item.name}
                        >
                            <ListItemIcon>
                                <Avatar {...stringAvatar(item.label)}/>
                            </ListItemIcon>
                            <ListItemText primary={item.label}/>
                        </ListItemButton>)}
                </List>
            </Collapse>
        </React.Fragment>
    );
}
